import React from "react";

const RadioGroup = ({
  name,
  mainLabel,
  secondaryLabel,
  register,
  required = true,
  onYes,
  onNo,
  yesValue = "Yes",
  noValue = "No",
  labelYes = "Yes",
  labelNo = "No",
  errors,
}) => (
  <>
    {mainLabel && <label className="labelName">{mainLabel}</label>}
    {secondaryLabel && <p className="licPara">{secondaryLabel}</p>}
    <div className="radioGroup">
      <label className="radioLabel">
        <p className="radioLabels">{labelYes}</p>
        <input
          type="radio"
          value={yesValue}
          {...register(name, { required })}
          onClick={onYes}
        />
        <span className="checkmark"></span>
      </label>
      <label className="radioLabel">
        <p className="radioLabels">{labelNo}</p>
        <input
          type="radio"
          value={noValue}
          {...register(name, { required })}
          onClick={onNo}
        />
        <span className="checkmark"></span>
      </label>
    </div>
    {errors && <span className="errorField radioError">Required</span>}
  </>
);

export default RadioGroup;
